export const daysInWeek = [
  { value: 'Monday', label: 'Thứ hai' },
  { value: 'Tuesday', label: 'Thứ ba' },
  { value: 'Wednesday', label: 'Thứ tư' },
  { value: 'Thursday', label: 'Thứ năm' },
  { value: 'Friday', label: 'Thứ sáu' },
  { value: 'Saturday', label: 'Thứ bảy' },
  { value: 'Sunday', label: 'Chủ nhật' },
];

export const dataPrice = [
  {
    id: 2,
    start_location: {
      name: 'Hà Nội',
      province: {
        id: 1,
        name: 'Thành phố Hà Nội',
      },
      district: null,
    },
    end_location: {
      name: 'Ninh Bình',
      province: {
        id: 25,
        name: 'Tỉnh Ninh Bình',
      },
      district: null,
    },
    depart_time: '07:00:00',
    arrive_time: '10:01:00',
    diff_day: 0,
    status: true,
    is_company_lock: false,
    is_agent_lock: false,
    is_api_lock: false,
    fare: [
      {
        price: 150000,
        group_name: 'Tầng 1',
      },
      {
        price: 100000,
        group_name: 'Tầng 2',
      },
    ],
  },
  {
    id: 5,
    start_location: {
      name: 'Hà Nội',
      province: {
        id: 1,
        name: 'Thành phố Hà Nội',
      },
      district: null,
    },
    end_location: {
      name: 'Hội An',
      province: {
        id: 33,
        name: 'Tỉnh Quảng Nam',
      },
      district: null,
    },
    depart_time: '07:00:00',
    arrive_time: '23:00:00',
    diff_day: 0,
    status: true,
    is_company_lock: false,
    is_agent_lock: false,
    is_api_lock: false,
    fare: [
      {
        price: 600000,
        group_name: 'Tầng 1',
      },
      {
        price: 580000,
        group_name: 'Tầng 2',
      },
    ],
  },
  {
    id: 8,
    start_location: {
      name: 'Ninh Bình',
      province: {
        id: 25,
        name: 'Tỉnh Ninh Bình',
      },
      district: null,
    },
    end_location: {
      name: 'Hội An',
      province: {
        id: 33,
        name: 'Tỉnh Quảng Nam',
      },
      district: null,
    },
    depart_time: '10:01:00',
    arrive_time: '23:00:00',
    diff_day: 0,
    status: true,
    is_company_lock: false,
    is_agent_lock: false,
    is_api_lock: false,
    fare: [],
  },
 
];
